import { FORM_ERROR } from 'final-form';

export interface Details {
  [key: string]: any;
}

export interface LunaError {
  type: string;
  details: Details;
}

export interface FieldError {
  path: string;
  message: string;
  details: Details;
}

export interface ConstraintViolationError extends LunaError {
  details: {
    fields: FieldError[];
  };
}

export interface Response {
  data: any;
  status: number;
}

export interface AjaxError extends Error {
  code: string;
  response: {
    data: any;
    status: number;
  };
}

function isLunaError(error: any): error is LunaError {
  return typeof error.details === 'object' && error.type;
}

function isAjaxError(error: any): error is AjaxError {
  return error.response && error.response.status;
}

function isConstraintViolationError(error: any): error is ConstraintViolationError {
  return (
    isLunaError(error) &&
    error.type === 'javax.validation.ConstraintViolationException' &&
    Array.isArray(error.details.fields)
  );
}

export function transformErrorsForFF(
  error: AjaxError | Error,
  defaultError = 'Something went wrong'
) {
  if (isAjaxError(error) && error.response.status >= 400 && error.response.status < 500) {
    if (isLunaError(error.response.data)) {
      if (isConstraintViolationError(error.response.data)) {
        return error.response.data.details.fields.reduce((result, fieldError) => {
          if (!result[fieldError.path]) {
            result[fieldError.path] = {
              message: fieldError.message,
              details: fieldError.details
            };
          }
          return result;
        }, {} as { [key: string]: { message: string; details: object } });
      } else {
        return {
          [FORM_ERROR]: {
            message: error.response.data.type.replace(/\./g, '-'),
            details: error.response.data.details
          }
        };
      }
    } else {
      return {
        [FORM_ERROR]: {
          message: defaultError
        }
      };
    }
  } else {
    return {
      [FORM_ERROR]: {
        message: defaultError
      }
    };
  }
}
